module.exports = __webpack_public_path__ + "img/ic-save.790730e1.svg";